module.exports = __webpack_public_path__ + "img/edc-CIMB-niaga.9c617490.png";